import { useCallback, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Reset } from '@factorialco/f0-react/icons/app'

import ToolbarButton from 'modules/expenses/components/ExpenseFileViewer/PdfViewer/ToolbarButton'

import {
  getNextRotation,
  getStoredRotation,
  storeRotation
} from 'modules/expenses/components/ExpenseFileViewer/rotationUtils'
import './index.styles.css'

interface Props {
  url: string
  fileId?: string | null
}

export const ImageViewer = ({ url, fileId }: Props) => {
  const [rotation, setRotation] = useState(() => getStoredRotation(fileId ?? null))

  const onRotate = useCallback(() => {
    setRotation((prev) => {
      const next = getNextRotation(prev)
      storeRotation(fileId ?? null, next)
      return next
    })
  }, [fileId])

  const isSideways = rotation === 90 || rotation === 270

  return (
    <div className="ImageViewer_container">
      <Box
        className="ImageViewer_toolbar"
        height="s64"
        background="grey000White"
        padding="s16"
        justifyContent="flexEnd"
        alignItems="center"
        flexDirection="row"
        border={{
          bottom: {
            width: 's1',
            style: 'solid',
            color: 'grey400'
          }
        }}
      >
        <Box gap="s8" flexDirection="row" alignItems="center">
          <ToolbarButton ariaLabel="Rotate" onClick={onRotate} icon={Reset} />
        </Box>
      </Box>

      <div className="ImageViewer_imageWrapper">
        <img
          src={url}
          className={`ImageViewer_image ${isSideways ? 'ImageViewer_image--sideways' : ''}`}
          style={{ transform: `rotate(${rotation}deg)` }}
        />
      </div>
    </div>
  )
}
